import React, { useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import NavBarAuth from '../../../../components/navbar/navbarAuth'
import { BaseURL } from '../../../../Files/BaseURL'
import AlertContext from '../../../../Context/Alert/AlertContext'

const OTPSignInScreen = () => {

    const [Email, setEmail] = useState('')
    const [countdown, setCountdown] = useState(30)
    const [canResend, setCanResend] = useState(false)
    const alertContext = useContext(AlertContext);
    const { showAlert } = alertContext;

    const fetchEmail = async () => {
        try {
            const response = await fetch(`${BaseURL}/api/auth/getuseremail`, {
                headers: {
                    "auth-token": sessionStorage.getItem("signtoken")
                }
            });
            const data = await response.json();
            setEmail(data.Email);
        } catch (error) {
            showAlert(error.message, 'danger');
        }
    };

    const handleResendOTP = async () => {
        if (!canResend) return;

        try {
            const response = await fetch(`${BaseURL}/api/auth/SendOTPagain`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ token: sessionStorage.getItem("signtoken") }),
            });
            const data = await response.json();
            showAlert(data.message, 'success');
            setCanResend(false);
            setCountdown(30);
        } catch (error) {
            console.error('Error resending OTP:', error);
            showAlert('Failed to resend OTP. Please try again.', 'danger');
        }
    };

    useEffect(() => {
        fetchEmail();
    }, []);

    useEffect(() => {
        let timer;
        if (countdown > 0) {
            timer = setInterval(() => {
                setCountdown((prev) => prev - 1);
            }, 1000);
        } else {
            setCanResend(true);
        }
        return () => {
            if (timer) clearInterval(timer);
        };
    }, [countdown]);

    const location = useLocation()
    return (
        <>
            <NavBarAuth />
            <div className="bg-gray-100">
                <div className='w-[35%] h-2 bg-primarygreen rounded-r-full'>
                </div>
            </div>
            <div className="flex justify-center items-center bg-gray-100 py-20">
                <div className="mx-6 bg-white p-8 rounded-lg shadow-md">
                    <h2 className="text-2xl font-pop font-bold mb-4">Welcome to Paycott.</h2>
                    <p className="text-gray-600 font-pop text-sm mb-3 max-w-sm">We sent a verification code to your email <span className='font-bold'>{Email}</span></p>
                    <p className="text-gray-600 font-pop text-sm mb-3 max-w-sm">Please check your email and click the link inside to confirm your email address</p>
                    <p className="text-gray-600 font-pop text-sm mb-6 max-w-sm">If you don't receive an email within 10 minutes, check your spam.</p>
                    <form>
                        <p className="text-gray-400 font-pop mt-6 max-w-sm text-center">Didn't receive the code</p>
                        {canResend ? (
                            <p
                                className="text-primarygreen font-pop cursor-pointer hover:underline mb-6 max-w-sm text-center"
                                onClick={handleResendOTP}
                            >
                                Resend
                            </p>
                        ) : (
                            <p className="text-gray-500 font-pop mb-6 max-w-sm text-center">
                                Resend available in {countdown} seconds
                            </p>
                        )}
                    </form>
                </div>
            </div>
        </>
    );
}

export default OTPSignInScreen